import Start_Main_Logo from "./Start_Main_Logo";
import { Outlet } from "react-router-dom";
import React from "react";

class Start_Main extends React.Component {
    render() {
        return(
            <div className="start_main">
                <Start_Main_Logo />
                <Outlet />
            </div>
        )
    }
}

export default Start_Main;